const getters = {
  currentLanguage: state => state.currentLanguage,
  languages: state => state.languages,
  bForced: state => state.bForced
};

export default getters;
